import classNames from "classnames";
import { FormikProps } from "formik";
import { useContext } from "react";
import { BlankMediaListFilter } from "../../../../generated/data-contracts";
import { FormikUtils } from "../../../../utils";
import { FilterActions } from "../../../shared/components/form";
import { AvisInputTextWithFilterType } from "../../../shared/components/inputs";
import { AvisContext } from "../../../shared/context/AvisContext";

interface IBlankMediaInfoFilterFormProps {
  bag: FormikProps<BlankMediaListFilter>;
  loading: boolean;
  filtered: boolean;
}

export function BlankMediaInfoFilterForm(
  props: Readonly<IBlankMediaInfoFilterFormProps>,
) {
  const { bag, loading } = props;
  const { res } = useContext(AvisContext);

  const classNameSecondColumn = classNames("blank-media-filter-name");
  return (
    <>
      <div className="row">
        <AvisInputTextWithFilterType<BlankMediaListFilter>
          className={classNameSecondColumn}
          label={`${res("public_BlankMedia_label_NMRCode")}/${res(
            "label_Title",
          )}`}
          bag={bag}
          bagField="personNameOrTaxpayerCode"
          bagFieldFilterType={"personNameOrTaxpayerCodeFilterType"}
          disabled={loading}
          minLength={2}
          maxLength={200}
          onKeyDown={(e) => FormikUtils.handleEnterKeyPress(e, bag.submitForm)}
        />
      </div>
      <FilterActions bag={bag} loading={loading} res={res} />
    </>
  );
}
